var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCallCenter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 108.3",
    style: {
      enableBackground: "new 0 0 85 108.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.346 -3.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M95.5,39.2c-1-1.3-2.5-2.2-4.1-2.5C87.8,17.8,73.1,4.2,55.9,4.2S23.9,17.8,20.3,36.7c-1.6,0.3-3.1,1.2-4.1,2.5 c-3,3.6-2.1,9.2-1.7,10.9c1.9,9.4,8.2,8.3,10.5,8c0.2,0,0.5-0.1,0.7-0.1c1.3,0,2.2-1.1,2.2-2.4c0-1.2-1-2.2-2.2-2.2 c-0.5,0-0.9,0.1-1.4,0.1c-2.2,0.3-4.3,0.7-5.4-4.4c-0.7-2.4-0.4-4.9,0.8-7.1c0.6-0.7,1.4-1,2.3-0.9h0.2c1.2,0.1,2.2-0.8,2.3-1.9 c2.7-17.7,16-30.4,31.4-30.4s28.6,12.8,31.4,30.4c0.2,1.1,1.2,1.9,2.3,1.9h0.2c0.9-0.1,1.7,0.3,2.3,0.9c1.1,2.2,1.4,4.7,0.8,7.1 c-1,5.1-3.2,4.8-5.4,4.4c-0.4-0.1-0.9-0.1-1.4-0.1c-0.5,0-1.1,0.2-1.5,0.6c-0.1,0.1-14.6,12.3-30.2,9c-0.6-2.1-2.9-3.3-5-2.6 c-2.1,0.6-3.3,2.9-2.6,5c0.5,1.7,2.1,2.8,3.8,2.8c0.9,0,1.7-0.3,2.4-0.8c2.3,0.5,4.7,0.8,7.1,0.8c13,0,23.8-7.8,26.8-10 c2.4,0.3,8.6,1.3,10.5-8C97.6,48.5,98.5,42.7,95.5,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M72.8,69.9c1.6-1.4,3-2.9,4.2-4.6c-3.3,1.5-6.7,2.6-10.3,3.3c-3.3,2.1-7.1,3.2-10.9,3.2 c-13,0-23.5-12.3-23.5-27.4s10.5-27.4,23.5-27.4s23.5,12.3,23.5,27.4c0,4.7-1,9.4-3.1,13.7c2.2-1.2,4.4-2.5,6.4-4 c0.9-3.1,1.4-6.4,1.4-9.7C84,26.9,71.5,12.5,56,12.5S27.9,26.9,27.9,44.5c-0.2,9.7,3.9,18.9,11.1,25.4c-13.6,3.5-24.2,13.1-24.2,22 c0,13,20.6,18.8,41.1,18.8s41.1-5.8,41.1-18.8C96.9,83,86.3,73.4,72.8,69.9z M55.9,106.2c-21.1,0-36.5-6-36.5-14.3 c0-6.4,9.5-15.5,23.2-18.2l1.6-0.3c7.3,4,16.2,4,23.5,0l1.6,0.3c13.7,2.7,23.2,11.7,23.2,18.2C92.3,100.2,76.9,106.2,55.9,106.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCallCenter2);
export default __webpack_public_path__ + "static/media/iconoCallCenter2.51092555.svg";
export { ForwardRef as ReactComponent };